import { gql } from "lib/apolloClient";

export const bulkUpdateConfigurationMutation = gql`
  mutation setConfigurationValue($input: [ConfigurationValueUpdateInput!]!) {
    platform {
      setMultipleConfigurationValueForEntityGroups(input: $input)
    }
  }
`;
